export default __webpack_public_path__ + "static/media/spotifyLogo.4bf5bfa8.png";